import React from 'react';
import { Collapse } from 'antd';
import './index.css';

export const PanelBox = (props) => {
  return (
    <Collapse.Panel {...props}>
      <div className="search-panel">
        {props.children}
      </div>
    </Collapse.Panel>
  );
}


